import axios from 'axios';

const PWCServerURL = process.env.REACT_APP_PWC_API_SERVER;

const PWCApi = axios.create({
  baseURL: PWCServerURL
});

const genPWCEmbeddedURL = (fileUUID, pageUUID, mode) =>
  `${PWCServerURL}/embedded/${fileUUID}?mode=${mode}&pageUUID=${pageUUID}`;

export const genPWCVoting = async (votingData) => {
  const res = await PWCApi({
    url: '/api/genDoc/voting',
    data: votingData,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  });

  return genPWCEmbeddedURL(res.data.fileUUID, res.data.pageUUID, 'SHOW');
};

export const genPWCShareYourOpinion = async (member) => {
  const res = await PWCApi({
    url: '/api/genDoc/shareYourOpinion',
    data: { member },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  });

  return genPWCEmbeddedURL(res.data.fileUUID, res.data.pageUUID, 'WRITE');
};

export const genPWCImageGrid = async (data) => {
  const bodyFormData = new FormData();
  bodyFormData.append(`layoutType`, data.layoutType);
  data.images.forEach((img) => {
    if (img && img.name) bodyFormData.append(`images`, new File([img], img.name));
  });

  const res = await PWCApi({
    url: '/api/genDoc/imageGrid',
    data: bodyFormData,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' }
  });

  return genPWCEmbeddedURL(res.data.data.fileUUID, res.data.data.pageUUID, 'SHOW');
};

export const genPWCSeating = async (data) => {
  const res = await PWCApi({
    url: '/api/genDoc/seating',
    data: data,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  });

  return genPWCEmbeddedURL(res.data.data.fileUUID, res.data.data.pageUUID, 'WRITE');
};

export const genPWCNewDocument = async () => {
  try {
    const res = await PWCApi({
      url: '/api/v1/template/createNewDocument',
      method: 'POST',
      withCredentials: true
    });

    return genPWCEmbeddedURL(res.data.data.fileUUID, res.data.data.pageUUID, 'WRITE');
  } catch (error) {
    throw error;
  }
};

export const getPWCDocInfo = async (docID) => {
  try {
    const res = await PWCApi({
      url: `/api/v1/doc/getDocInfo/${docID}`,
      method: 'GET',
      withCredentials: true
    });

    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getReauthorizationUrl = () =>
  `${PWCServerURL}/api/v1/auth/whaleSpace/reAuthorization?redirect_path=${encodeURIComponent(
    '/autoClose/index.html'
  )}`;

export const getPWCCurrentLoginStatus = async () => {
  try {
    return await PWCApi.get('/api/v1/user/getCurrentLoginStatus', {
      withCredentials: true
    });
  } catch (error) {
    throw error;
  }
};
